<template>
    <div v-wechat-title="title" style="height: 100%">
        <div v-if="this.charge_template_group.length > 0">
            <crud-facecade-tree
                ref="template-list"
                :url="url"
                :treeCol="treeCol"
                :columns="columnList"
                :expandall="true"
                :buttons="[]"
                dialogWidth="95%"
                :parentField="parentField"
                :tableHeight="tableHeight"
                :addButton="{ enabled: false, permission: 'default' }"
                :updateButton="{ enabled: false, permission: 'default' }"
                :stripe="false"
                @loadingEditTemplate="loadingEditTemplate"
            >
                <slot slot="filter">
                    <el-col :span="4">
                        <item-input type="groupselect" v-model="dic_ward_id" :options="wardOptions" :clearable="true" placeholder="请选择区域"></item-input>
                    </el-col>
                    <el-col :span="4" v-show="region_type == 1 && permissions && permissions.findIndex(item => item.permission === `tmp:alltmp`) != -1">
                        <item-input type="select" v-model="dic_worker_id" :options="usernameList" :clearable="true" placeholder="请选择所属人"></item-input>
                    </el-col>
                    <el-col :span="4">
                        <item-input type="select" v-model="charge_type" :options="chargetypeList" :clearable="true" placeholder="请选择模板类型"></item-input>
                    </el-col>
                </slot>
                <slot slot="filter-select">
                    <el-col :span="8" class="padding-right10" style="display: flex; justify-content: space-around; line-height: 100%">
                        <span style="display: inline-block; width: 60%; word-wrap: break-word; white-space: normal; text-align: center">可用范围：</span>
                        <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                    </el-col>
                </slot>
                <slot slot="filter-after">
                    <el-button type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                    <el-button type="primary" size="mini" @click="loadingNewTemplate()" title="">创建<i class="el-icon--right"></i></el-button>
                </slot>
            </crud-facecade-tree>
        </div>
        <div v-else>
            <crud-facecade
                ref="template-list"
                :url="url"
                :columns="columnList"
                :buttons="[]"
                :tableHeight="tableHeight"
                dialogWidth="80%"
                :addButton="{ enabled: false, permission: 'default' }"
                :updateButton="{ enabled: false, permission: 'default' }"
                @loadingEditTemplate="loadingEditTemplate"
            >
                <slot slot="filter">
                    <el-col :md="6" :xl="4">
                        <item-input type="groupselect" v-model="dic_ward_id" :options="wardOptions" placeholder="请选择区域"></item-input>
                    </el-col>
                    <el-col :span="4" v-show="region_type == 1 && permissions && permissions.findIndex(item => item.permission === `tmp:alltmp`) != -1">
                        <item-input type="select" v-model="dic_worker_id" :options="usernameList" :clearable="true" placeholder="请选择所属人"></item-input>
                    </el-col>
                    <el-col :span="4">
                        <item-input type="select" v-model="charge_type" :options="chargetypeList" :clearable="true" placeholder="请选择模板类型"></item-input>
                    </el-col>
                </slot>
                <slot slot="filter-select">
                    <el-col :span="8" class="padding-right10" style="display: flex; justify-content: space-around; line-height: 100%">
                        <span style="display: inline-block; width: 60%; word-wrap: break-word; white-space: normal; text-align: center">可用范围：</span>
                        <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                    </el-col>
                </slot>
                <slot slot="filter-after">
                    <el-button type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                    <el-button type="primary" size="mini" @click="loadingNewTemplate()" title="">创建<i class="el-icon--right"></i></el-button>
                </slot>
            </crud-facecade>
        </div>
        <EditTemplate :visible.sync="saveas.dialogFormVisible" :data="saveas.data" @save-success="saveAsSuccess"></EditTemplate>
        <!-- <SaveAs :visible.sync="saveas.dialogFormVisible" :data="saveas.data" @save-success="saveAsSuccess"></SaveAs> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditTemplate from './EditTemplate.vue'
import SaveAs from './SaveAs.vue'
export default {
    name: `AnesthesiaChargeTemplate`,
    components: { SaveAs, EditTemplate },
    props: {},
    created() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        if (this.surgeryId > 0) {
            this.loadSurgeryInfo()
        }
        this.loadOwnerList()
        this.loadConfigs().then(() => {
            this.loadChargeItemTypes()
        })
        this.loadPermissions()
    },
    data() {
        return {
            permissions: [],
            title: `计费模板`,
            parentField: `group_name`,
            treeCol: `模板/分组名称`,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            charge_item_types: [],
            dic_worker_id: null,
            usernameList: [],
            chargetypeList: [{ value: 0, label: `手术计费` }, { value: 1, label: `麻醉计费` }],
            charge_type: this.$route.query.charge_type || null,
            charge_item_type: ``,
            selectedRow: null,
            url: {
                baseURL: `api/AcisSystem/ChargeTemplate`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row)
                },
                put: row => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.put(`api/AcisSystem/ChargeTemplate/Put`, {
                            id: row.id,
                            name: row.name,
                            enum_charge_type: row.enum_charge_type,
                            items: _.reduce(
                                _.groupBy(row.items, `dic_chrg_item.value`),
                                function(result, value, key) {
                                    let sOne =
                                        _.find(value, d => {
                                            return d.id > 0
                                        }) || value[0]
                                    let r = {
                                        id: sOne.id,
                                        parent_id: sOne.parent_id,
                                        additional_type: sOne.additional_type,
                                        charg_rate: sOne.charg_rate,
                                        total_price: sOne.total_price,
                                        item_name: sOne.dic_chrg_item.label,
                                        dic_chrg_item_id: key,
                                        amount: _.sumBy(value, `amount`),
                                        display_order: sOne.display_order,
                                        dic_section_id: sOne.execute_dept
                                    }
                                    result.push(r)
                                    return result
                                },
                                []
                            ),
                            regions:
                                row.region_type == 1
                                    ? [{ owner: that.currentUser.username }]
                                    : row.dic_ward_ids.map(d => {
                                        return {
                                            sys_charge_template_id: row.id,
                                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                        }
                                    })
                        })
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                }
            },
            item_configs: [],
            drug_section: {},
            region_type: 2,
            charge_template_group: this.$root.ChargeTemplateGroup && this.$root.ChargeTemplateGroup != `` && JSON.parse(this.$root.ChargeTemplateGroup) || [],
            onlySimpleWard: this.$root.OnlySimpleWard,
            surgeryId: null,
            chargeItemSelectConfig: this.$root.ChargeItemSelectConfig || 0,
            // 0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述
            chargeColumns: [
                { prop: `code`, label: `编码`, minWidth: 150, id: `0` },
                { prop: `spec`, label: `规格`, minWidth: 100, id: `1` },
                { prop: `price`, label: `价格`, minWidth: 80, id: `2` },
                { prop: `sell_unit`, label: `单位`, minWidth: 80, id: `3` },
                { prop: `firm`, label: `厂商`, minWidth: 120, id: `4` },
                { prop: `uni_charge_code`, label: `收费编码`, minWidth: 100, id: `5` },
                { prop: `medical_type`, label: `医保`, minWidth: 80, id: `6` },
                { prop: `inventory`, label: `库存`, minWidth: 80, id: `7` },
                { prop: `description`, label: `描述`, minWidth: 100, id: `8` }
            ]
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`, `sys_enums`, `screenHeight`, `section_auth`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            return wards
        },
        regionTypeOption() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            r.push({ label: `区域`, value: 2 })
            console.log(`regionTypeOption`, r)
            return r
        },
        hasRegionTypePermission() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            if (_.find(this.permissions, { permission: `tmp:area_read` }) != undefined || _.find(this.permissions, { permission: `tmp:area_edit` }) != undefined || _.find(this.permissions, { permission: `tmp:alltmp` }) != undefined) {
                r.push({ label: `区域`, value: 2 })
            }
            return r
        },
        saveAsColumns() {
            return _.filter(this.columnList, { isCreatable: true })
        },
        columnList() {
            let me = this
            let username = (this.currentUser && this.currentUser.username) || `--`
            // var edittmp = (this.permissions && (this.permissions.findIndex(item => item.permission === `tmp:area_edit`) !== -1 ||
            //     this.permissions.findIndex(item => item.permission === `tmp:alltmp`) !== -1))
            var deletetmp = (this.permissions && (this.permissions.findIndex(item => item.permission === `tmp:area_delete`) !== -1 ||
                this.permissions.findIndex(item => item.permission === `tmp:alltmp`) !== -1))
            let cols = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    readonly: function(that, { row }) {
                        return row.id <= 0
                    },
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `模板/分组名称`,
                    isListable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `searchName`,
                    label: `子项查询`,
                    width: 80,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `select`,
                    prop: `enum_charge_type`,
                    label: `类型`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.chargetypeList,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.regionTypeOption,
                    default: 2
                },
                {
                    type: `string`,
                    prop: `abbr`,
                    label: `缩写`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `dic_worker_name`,
                    label: `所属人`,
                    isListable: me.region_type == 1
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    // width: "180",
                    isListable: me.region_type == 2,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `修改人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `修改时间`,
                    width: `140`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.id > 0) {
                            if (row.enum_surgery_status !== -1) {
                                let rowbuttons = [
                                    {
                                        class: `is-plain`,
                                        label: `编辑`,
                                        icon: ``,
                                        type: `primary`,
                                        emit: `loadingEditTemplate`,
                                        permission: `default`
                                    }]

                                if (username == row.owner || deletetmp) {
                                    rowbuttons.push({
                                        class: `is-plain`,
                                        label: `删除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `DeleteData`,
                                        permission: `default`
                                    })
                                }
                                return rowbuttons
                            } else {
                                return [

                                    {
                                        label: `编辑`,
                                        icon: ``,
                                        type: `primary`,
                                        emit: `LoadingUpdateView`,
                                        permission: `default`
                                    }
                                ]
                            }
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `items`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `number`,
                            prop: `display_order`,
                            label: `排序`,
                            width: 60,
                            isListable: true,
                            readonly: false,
                            default: 1
                        },
                        {
                            type: this.chargeItemSelectConfig == 1 ? `tableselect` : `remoteselect`,
                            // type: `remoteselect`,
                            prop: `dic_chrg_item`,
                            label: `项目名称`,
                            // width: "400",
                            isListable: true,
                            readonly: false,
                            options: (that, { row }) => {
                                return q => {
                                    q.chargeSourceHospitalWardId = (me.onlySimpleWard == `1`) ? me.active_ward.groupId : 0
                                    return this.loadChargeItemList(q)
                                }
                            },
                            selectColumn: this.chargeColumns,
                            change: (that, { row, index }) => {
                                if (row.dic_chrg_item && row.dic_chrg_item.value) {
                                    let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/Get/${row.dic_chrg_item.value}`)
                                    let req1 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=DefaultDrugSection`)
                                    this.myaxios.all(req, req1).then(([data, data1]) => {
                                        let id = (data.dic_chrg_item_type_id == 1 || data.is_drug_type) ? this.drug_section.id : null
                                        this.$set(row, `display_order`, index + 1)
                                        this.$set(row, `spec`, data.spec)
                                        this.$set(row, `additional_type`, data.additional_type)
                                        this.$set(row, `sell_unit`, data.sell_unit)
                                        this.$set(row, `price`, data.price)
                                        this.$set(row, `dic_chrg_item_type`, data.dic_chrg_item_type)
                                        this.$set(row, `charg_rate`, data.charg_rate)

                                        this.$set(row, `execute_dept`, id)
                                    })
                                } else {
                                    this.$set(row, `additional_type`, ``)
                                    this.$set(row, `spec`, ``)
                                    this.$set(row, `sell_unit`, ``)
                                    this.$set(row, `price`, ``)
                                    this.$set(row, `dic_chrg_item_type`, ``)
                                    this.$set(row, `charg_rate`, ``)
                                }
                            }
                        },
                        {
                            type: `string`,
                            prop: `additional_type`,
                            label: `加收类型`,
                            width: 140,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `spec`,
                            label: `规格`,
                            width: 140,
                            isListable: true
                        },
                        {
                            type: `float`,
                            prop: `amount`,
                            label: `计费数量`,
                            decimal_places: 2,
                            width: 100,
                            isListable: true,
                            readonly: false,
                            change: (that, { row, index }) => {
                                let totalprice = row.price * row.amount
                                this.$set(row, `total_price`, totalprice)
                            }

                        },
                        {
                            type: `string`,
                            prop: `sell_unit`,
                            label: `计价单位`,
                            width: 80,
                            isListable: true
                        }, {
                            type: `string`,
                            prop: `charg_rate`,
                            label: `比例`,
                            width: 80,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `total_price`,
                            label: `计价金额`,
                            width: 80,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `price`,
                            label: `单价（元）`,
                            width: 80,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `dic_chrg_item_type`,
                            label: `项目类型`,
                            width: 80,
                            isListable: true
                        }
                        // {
                        //     type: `select`,
                        //     prop: `execute_dept`,
                        //     label: `执行科室`,
                        //     options: this[`section_auth`],
                        //     readonly: false,
                        //     isListable: true
                        // }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 300
                    }
                }
            ]
            return cols
        }
    },
    methods: {
        loadSurgeryInfo(surgeryId) {
            return new Promise(resolve => {
                if (surgeryId > 0) {
                    let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${surgeryId}`)
                    req.then(surgery => {
                        this.surgeryInfo = surgery
                        resolve(surgery)
                    })
                } else {
                    resolve(null)
                }
            })
        },
        loadOwnerList() {
            let that = this
            let hospitalwardid = 0
            if (that.onlySimpleWard == `1` && !that.surgeryId) {
                // 这里是模板
                hospitalwardid = that.active_ward.groupId
            }
            if (that.surgeryId > 0) {
                if (that.surgeryInfo && that.surgeryInfo.source_hospital_ward_id) {
                    // 这里是患者应用
                    hospitalwardid = that.surgeryInfo.source_hospital_ward_id
                }
            }
            hospitalwardid = this.region_type == 1 ? 0 : hospitalwardid
            let req = that.myaxios.get(`api/AcisSystem/ChargeTemplate/GetTemplate?hospital_ward_id=${hospitalwardid}`)
            req.then(data => {
                that.usernameList = []
                let ownerlist = _.filter(data, t => {
                    return t.dic_worker_id && t.dic_worker_name
                })
                if (that.charge_type == 0 || that.charge_type == 1) {
                    data = _.filter(data, function(c) {
                        return c.enum_charge_type == that.charge_type
                    })
                }
                let ownergroup = ownerlist && _.groupBy(ownerlist, `dic_worker_id`)
                _.forEach(ownergroup, (g) => {
                    let r = g[0] && {
                        value: g[0].dic_worker_id,
                        label: g[0].dic_worker_name,
                        jianpin: g[0].dic_worker_abbr
                    }
                    that.usernameList.push(r)
                })
            }).catch(e => {})
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        loadTemplates(resolve, reject) {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`)
            let hospitalwardid = 0
            if (that.onlySimpleWard == `1` && !that.surgeryId) {
                // 这里是模板
                hospitalwardid = that.active_ward.groupId
            }
            if (that.surgeryId > 0) {
                if (that.surgeryInfo && that.surgeryInfo.source_hospital_ward_id) {
                    // 这里是患者应用
                    hospitalwardid = that.surgeryInfo.source_hospital_ward_id
                }
            }
            hospitalwardid = this.region_type == 1 ? 0 : hospitalwardid

            let req1 = that.myaxios.get(`api/AcisSystem/ChargeTemplate/GetTemplate?hospital_ward_id=${hospitalwardid}`)
            this.myaxios.all(req, req1).then(([permissions, data]) => {
                this.permissions = permissions
                if (this.permissions) {
                    // 若有全部模板权限，则不做数据过滤
                    if (this.permissions.findIndex(item => item.permission === `tmp:alltmp`) === -1) {
                        // 有区域模板查看缺陷时可查看自己个人和区域的
                        if (this.permissions.findIndex(item => item.permission === `tmp:area_read`) !== -1) {
                            data = _.filter(data, x => (x.owner == ((this.currentUser && this.currentUser.username) || `--`) || x.owner == null))
                        } else {
                            // 没有区域查看权限也没有全局模板权限时，只看自己的
                            data = _.filter(data, x => x.owner == ((this.currentUser && this.currentUser.username) || `--`))
                        }
                    }
                } else {
                    // 未获取到权限配置时，仅查看自己个人模板
                    data = _.filter(data, x => x.owner == ((this.currentUser && this.currentUser.username) || `--`))
                }

                if (that.dic_worker_id) {
                    data = _.filter(data, function(c) {
                        return c.dic_worker_id == that.dic_worker_id
                    })
                }

                if (that.charge_type == 0 || that.charge_type == 1) {
                    data = _.filter(data, function(c) {
                        return c.enum_charge_type == that.charge_type
                    })
                }

                if (this.hasRegionTypePermission.length == 1) {
                    that.region_type = 2
                }
                _.forEach(data, d => {
                    d.class_name = `ignore-drag`
                    d.drag_html = `<div><b>${d.name}</b></div>`
                })

                let groupId = _.groupBy(data, `id`)
                let templates = []
                _.forEach(groupId, g => {
                    let r = { ...g[0] }
                    r.dic_ward_ids =
                        !r.owner &&
                        g.map(d => {
                            return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`)
                        })
                    r.region_type = r.owner ? 1 : 2
                    r.group_name = this.getGroupNameById(r.group_id)
                    if (that.dic_ward_id) {
                        if (_.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1) {
                            templates.push(r)
                        }
                    } else {
                        templates.push(r)
                    }
                })
                if (that.region_type) { //  && this.charge_template_group.length > 0
                    templates = _.filter(templates, function(c) {
                        return c.region_type == that.region_type
                    })
                }

                let templatelist = this.charge_template_group.length > 0 ? this.loadgrouprows(templates) : templates.sort((a, b) => a.display_order - b.display_order)
                resolve(templatelist)
            })
        },
        loadgrouprows(searchResult) {
            let templates = []
            let groups = _.groupBy(searchResult, `group_name`)
            let groupid = 0
            _.forEach(groups, (value, key) => {
                groupid = groupid - 1
                let grouprow = {
                    id: groupid,
                    group_name: key,
                    name: key,
                    class_name: `groupClass`,
                    children: []
                }
                if (!key || key == `null`) {
                    grouprow.id = -999999
                    grouprow.group_name = `未分组`
                    grouprow.name = `未分组`
                }
                grouprow.children = value.sort((a, b) => a.display_order - b.display_order)
                templates.push(grouprow)
            })
            templates = templates.sort((a, b) => b.id - a.id)
            console.log(`templates`)
            console.log(templates)
            return templates
        },
        getGroupNameById(id) {
            let item = _.find(this.charge_template_group, x => x.value == id)
            if (item) { return item.label || `` }
            return `其它`
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeTemplate/Get/${row.id}`)
                req.then(data => {
                    let dd = { ...row }
                    dd.items =
                        _.map(_.orderBy(data.items, `display_order`), d => {
                            d.charge_item.execute_dept = d.execute_dept
                            let r = { ...d.charge_item }

                            Object.assign(r, {
                                id: d.id,
                                parent_id: d.parent_id,
                                id_guid: d.id_guid,
                                parentid_guid: d.parentid_guid,
                                dic_chrg_item: { value: d.dic_chrg_item_id, label: r.name, jianpin: r.abbr, dic_chrg_item_type_id: r.dic_chrg_item_type_id },
                                dic_chrg_item_id: d.dic_chrg_item_id,
                                amount: d.amount,
                                additional_type: d.additional_type,
                                charg_rate: d.charg_rate,
                                total_price: d.total_price,
                                display_order: d.display_order,
                                execute_dept: d.dic_section_id != 0 ? d.dic_section_id * 1 : d.execute_dept * 1,
                                execute_dept_id: d.dic_section_id,
                                dic_chrg_item_type: this.getChargeItemTypeName(r.dic_chrg_item_type_id),
                                dic_chrg_item_type_id: r.dic_chrg_item_type_id
                            })
                            return r
                        }) || []
                    dd.enum_charge_category = !dd.enum_charge_category ? 0 : dd.enum_charge_category
                    resolve(dd)
                }).catch(e => reject(e))
            })
        },
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`api/AcisSystem/ChargeTemplate/Post`, {
                    name: row.name,
                    enum_charge_type: row.enum_charge_type,
                    items: _.reduce(
                        _.groupBy(row.items, `dic_chrg_item.value`),
                        function(result, value, key) {
                            let sOne =
                                _.find(value, d => {
                                    return d.id > 0
                                }) || value[0]
                            let r = {
                                dic_chrg_item_id: key,
                                amount: _.sumBy(value, `amount`),
                                display_order: sOne.display_order,
                                dic_section_id: sOne.execute_dept
                            }
                            result.push(r)
                            return result
                        },
                        []
                    ),
                    regions:
                        row.region_type == 1
                            ? [{ owner: this.currentUser.username }]
                            : row.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        },
        loadingEditTemplate({ row }) {
            this.loadOne(row)
                .then(data => {
                    let r = { ...data }
                    this.saveas.dialogFormVisible = true
                    r.title = `编辑`
                    this.saveas.data = r
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadingNewTemplate() {
            let rtype = 1
            if (this.permissions && (this.permissions.findIndex(item => item.permission === `tmp:area_edit`) !== -1 || this.permissions.findIndex(item => item.permission === `tmp:alltmp`) !== -1)) {
                rtype = 2
            }
            let data = {
                name: ``,
                title: `新增`,
                enum_charge_type: 1,
                region_type: rtype, // 默认可选范围为区域
                dic_ward_ids: [],
                items: [],
                enum_charge_category: 0
            }
            this.saveas.data = data
            this.saveas.dialogFormVisible = true
        },
        saveAsSuccess() {
            this.ReloadListData()
        },
        loadChargeItemList(q) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeItem/SearchChargeModel?keyword=${q && q.keyword}&chargeSourceHospitalWardId=${q && q.chargeSourceHospitalWardId}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ChargeItemCodeConfig`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.item_configs = data1.value.split(`|`)
                    data = _.map(data, d => {
                        let codes = []
                        for (let item of this.item_configs) {
                            if (item === `0`) codes.push(d.code)
                            if (item === `1`) codes.push(d.spec || `--`)
                            if (item === `2`) codes.push(d.price || `--`)
                            if (item === `3`) codes.push(d.sell_unit || `--`)

                            if (item === `4`) codes.push(d.firm || `--`)
                            if (item === `5`) codes.push(d.uni_charge_code || `--`)
                            if (item === `6`) codes.push(d.medical_type || `--`)
                            if (item === `7`) codes.push(`库存:${d.inventory || `--`}`)
                            if (item === `8`) codes.push(d.description || `--`)
                        }
                        return {
                            ...d,
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: codes.join(`/`)
                        }
                    })
                    resolve(data)
                })
            })
        },
        loadConfigs() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Section/Get`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    let info = _.filter(data, { key: `DefaultDrugSection` })[0] && _.filter(data, { key: `DefaultDrugSection` })[0].value
                    let config = _.filter(data, { key: `ChargeItemCodeConfig` })[0] && _.filter(data, { key: `ChargeItemCodeConfig` })[0].value
                    this.item_configs = config.split(`|`)
                    let code = info.split(`|`)[0]
                    let name = info.split(`|`)[1]
                    this.drug_section.id =
                        (_.filter(data1, d => {
                            return d.code == code && d.name == name
                        })[0] &&
                            _.filter(data1, d => {
                                return d.code == code && d.name == name
                            })[0].id) ||
                        0
                    this.drug_section.name =
                        (_.filter(data1, d => {
                            return d.code == code && d.name == name
                        })[0] &&
                            _.filter(data1, d => {
                                return d.code == code && d.name == name
                            })[0].name) ||
                        undefined
                    this.setChargeColumns()
                    resolve(this.drug_section)
                })
            })
        },
        setChargeColumns() {
            let that = this
            let resultColumns = [
                { prop: `name`, label: `项目名称`, minWidth: 250, fixed: `left` }
            ]
            that.item_configs.forEach(item => {
                let codeInfo = _.find(that.chargeColumns, { id: item })
                if (codeInfo) {
                    resultColumns.push(codeInfo)
                }
            })
            console.log(resultColumns)
            this.chargeColumns = resultColumns
        },
        loadChargeItemTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                    .then(data => {
                        this.charge_item_types = data
                        resolve(this.charge_item_types)
                    })
            })
        },
        getChargeItemTypeName(id) {
            let item = _.find(this.charge_item_types, x => x.value == id)
            return item.label || ``
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        },
        dic_worker_id: function() {
            this.ReloadListData()
        },
        region_type: function() {
            this.ReloadListData()
        },
        charge_type: function() {
            this.ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charge/Anesthesia/Template.vue